<!--New design-->
<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="blue_header">
		<h1 class="heading">Manage {{this.lblHeading}}</h1>
	</div>
	<label class="sb-txt">From here you can run the processes that create notifications and reminders based on numerous
		dates and statuses. In the processes, the status of permits may also be altered. The correspondence items are
		inserted into the correspondence subsystem from where the emails and SMSes are sent.<br>Click on the run icon to
		run
		a process. The process will display a summary when it is complete.</label>

	<!--New Design-->
	<div class="row justify-content-center">
		<div class="col-sm-6">
			<div class="card">
				<table class="table table-sm">
					<thead>
						<tr>
							<th class="smallbox" title="Synchronise the balance with Evolution debtor account balance">
								1. Synchronise
								the balance with Evolution debtor account balance</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="smallbox" style="background: #fff;">Run the process described above</td>
							<td class="smallbox" style="background: #fff;">
								<div class="main-btn rounded-circle rmp-all" title="Run task.."
									(click)="synchroniseBalance()" rel="tooltip" data-placement="top">
									<span class="fa fa-play-circle-o fa-2x"
										style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
								</div>
							</td>
						</tr>
						<tr>
							<td class="smallbox" colspan="2">
								<fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
									<legend class="scheduler-border tsk-display">Process Report</legend>
									<table id="vTypes" border="1" class="table tbl-stl"
										*ngIf="isSynchroniseReportVisible" style="margin-bottom: 0px !important;">
										<thead class="thead-inverse hgt-btn">
											<tr style="vertical-align:middle;">
												<th style="vertical-align:middle; padding-bottom: 2px; padding-top: 2px;"
													class="bfr-end-col">
													Source
												</th>
												<th style="vertical-align:middle; padding-bottom: 2px; padding-top: 2px;"
													class="end-col">
													Description/Notes
												</th>
											</tr>
										</thead>
										<tr style="height: 10px !important;">
											<td class="bfr-end-col"># carrier accounts:
												{{synchroniseAllAccountsReport["CarrierAccounts"]}}
											</td>
											<td class="end-col">Carrier accounts that were checked.</td>
										</tr>
										<tr style="height: 10px !important;">
											<td class="bfr-end-col"># carriers as debtors:
												{{synchroniseAllAccountsReport["CarriersAsDebtors"]}}</td>
											<td class="end-col">Carrier accounts with matching debtor account.</td>
										</tr>
										<tr style="height: 10px !important;">
											<td class="bfr-end-col"># debtor accounts created:
												{{synchroniseAllAccountsReport["AccountCreated"]}}</td>
											<td class="end-col">New debtor accounts that were created.</td>
										</tr>
										<tr style="height: 10px !important;">
											<td class="bfr-end-col"># balance updated:
												{{synchroniseAllAccountsReport["BalanceChanged"]}}</td>
											<td class="end-col">How many iCBMS balances were updated.</td>
										</tr>
										<tr style="height: 10px !important;">
											<td class="bfr-end-col"># balance the same:
												{{synchroniseAllAccountsReport["BalanceNotChanged"]}}
											</td>
											<td class="end-col">Number where balances matched.</td>
										</tr>

									</table>
								</fieldset>
							</td>
						</tr>
					</tbody>

				</table>
			</div>
		</div>

		<div class="col-sm-6">
			<div class="card">
				<table class="table table-sm">
					<thead>
						<tr>
							<th class="smallbox" title="Create invoices for permit fees paid">2. Create invoices for
								permit
								fees paid
							</th>
							<th></th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="smallbox" style="background: #fff;">Run the process described above</td>
							<td class="smallbox" style="background: #fff;">
								<div class="main-btn rounded-circle rmp-all" title="Run task.."
									(click)="runInvoicePermitsTask()" rel="tooltip" data-placement="top">
									<span class="fa fa-play-circle-o fa-2x"
										style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
								</div>
							</td>
						</tr>
						<tr>
							<td class="smallbox" colspan="2">
								<fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
									<legend class="scheduler-border tsk-display">Process Report</legend>
									<ng-container *ngIf="isInvoicePermitsVisible">
										<label style="color: #413f3f; font-size: 13px; font-weight: bold;">#
											applications
											processed:
											{{InvoicePermitsReport["app_count"]}}</label> <br />
										<label style="color: #413f3f; font-size: 13px; font-weight: bold;"># permits
											processed:
											{{InvoicePermitsReport["permit_count"]}}</label>
										<br />
										<label style="color: #413f3f; font-size: 13px; font-weight: bold;"># application
											fees and amount
											invoiced:
											{{InvoicePermitsReport["app_fee_count"]}} and
											{{InvoicePermitsReport["invoice_count"]}}</label>
										<br />
										<label style="color: #413f3f; font-size: 13px; font-weight: bold;"># permits
											fees
											and amount invoiced:
											{{InvoicePermitsReport["permit_fee_count"]}} and
											{{InvoicePermitsReport["invoice_count"]}}</label>
										<br />
										<label style="color: #413f3f; font-size: 13px; font-weight: bold;"># invoices
											and
											total:
											{{InvoicePermitsReport["invoice_count"]}}</label>
									</ng-container>
								</fieldset>
							</td>
						</tr>
					</tbody>

				</table>
			</div>
		</div>
	</div>



	<!--End New-->




	<!-- <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Synchronise the balance with Evolution debtor account balance</legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="synchroniseBalance()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isSynchroniseReportVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <table id="vTypes" border="1" class="table tbl-stl" style="margin-bottom: 0px !important;">
        <thead class="thead-inverse hgt-btn">
          <tr style="vertical-align:middle;">
            <th style="vertical-align:middle; padding-bottom: 2px; padding-top: 2px;" class="bfr-end-col">
              Source
            </th>
            <th style="vertical-align:middle; padding-bottom: 2px; padding-top: 2px;" class="end-col">
              Description/Notes
            </th>
          </tr>
        </thead>
        <tr style="height: 10px !important;">
          <td class="bfr-end-col"># carrier accounts: {{synchroniseAllAccountsReport["CarrierAccounts"]}}</td>
          <td class="end-col">Carrier accounts that were checked.</td>
        </tr>
        <tr style="height: 10px !important;">
          <td class="bfr-end-col"># carriers as debtors: {{synchroniseAllAccountsReport["CarriersAsDebtors"]}}</td>
          <td class="end-col">Carrier accounts with matching debtor account.</td>
        </tr>
        <tr style="height: 10px !important;">
          <td class="bfr-end-col"># debtor accounts created: {{synchroniseAllAccountsReport["AccountCreated"]}}</td>
          <td class="end-col">New debtor accounts that were created.</td>
        </tr>
        <tr style="height: 10px !important;">
          <td class="bfr-end-col"># balance updated: {{synchroniseAllAccountsReport["BalanceChanged"]}}</td>
          <td class="end-col">How many iCBMS balances were updated.</td>
        </tr>
        <tr style="height: 10px !important;">
          <td class="bfr-end-col"># balance the same: {{synchroniseAllAccountsReport["BalanceNotChanged"]}}</td>
          <td class="end-col">Number where balances matched.</td>
        </tr>
    
      </table>
    </fieldset>
  </fieldset>

  
  <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Create invoices for permit fees paid
    </legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runInvoicePermitsTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isInvoicePermitsVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># applications processed:
        {{InvoicePermitsReport["app_count"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># permits processed:
        {{InvoicePermitsReport["permit_count"]}}</label>
      <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># application fees and amount invoiced:
        {{InvoicePermitsReport["app_fee_count"]}} and {{InvoicePermitsReport["invoice_count"]}}</label>
      <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># permits fees and amount invoiced:
        {{InvoicePermitsReport["permit_fee_count"]}} and {{InvoicePermitsReport["invoice_count"]}}</label>
      <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># invoices and total:
        {{InvoicePermitsReport["invoice_count"]}}</label>
    </fieldset>
  </fieldset> -->
	<br />
</div>
<!--End new design -->